import { PageContext } from '@websrc/App/AppContext'
import { AppProvider } from '@websrc/App/AppProvider'
import { pathToPageName } from '@websrc/App/Helpers/pathToPageName'
import React from 'react'

import { Lesson, LessonProps } from './Lesson'

export interface LessonPageProps {
  pageContext: PageContext & {
    lesson: LessonProps
  }
}

export default function LessonPage({ pageContext }: LessonPageProps) {
  const { appContext, lesson } = pageContext
  const [siteSection, pageName] = pathToPageName(appContext.path)
  const pageType = 'lesson-plan'

  return (
    <AppProvider
      {...appContext}
      matomoPageTemplate={'lesson_plans'}
      pageName={pageName}
      pageType={pageType}
      siteSection={siteSection}
    >
      <Lesson {...lesson} />
    </AppProvider>
  )
}
